import { render, staticRenderFns } from "./TransferMachine.vue?vue&type=template&id=7f5d31e2&scoped=true&"
import script from "./TransferMachine.vue?vue&type=script&lang=js&"
export * from "./TransferMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5d31e2",
  null
  
)

export default component.exports